var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancelIconSummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30809",
    "data-name": "Group 30809",
    transform: "translate(-380 -514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50153",
    "data-name": "Path 50153",
    d: "M9,0A9,9,0,1,1,0,9,9,9,0,0,1,9,0Z",
    transform: "translate(380 514)",
    fill: "#ec5959"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Cross_1707163",
    transform: "translate(356.264 490.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(28.737 28.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M29.012,981.374a.941.941,0,0,1,1.33,0l2.394,2.394,2.394-2.394a.941.941,0,0,1,1.33,1.33L34.067,985.1l2.394,2.394a.941.941,0,1,1-1.33,1.33l-2.394-2.395-2.394,2.394a.941.941,0,1,1-1.33-1.33l2.394-2.395L29.012,982.7a.94.94,0,0,1,0-1.33Z",
    transform: "translate(-28.737 -981.099)",
    fill: "#fff",
    stroke: "#ec5959",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIconSummary);
export default __webpack_public_path__ + "static/media/CancelIconSummary.32d4d520.svg";
export { ForwardRef as ReactComponent };